<template>
    <div class="stati-multi-select">
        <CheckboxSelect
            :id="id"
            :options="options"
            :size="size"
            :selectSize="5"
            :isBusy="busy"
            :sortActive="true"
            :disabled="disabled"
            :value="localValue"
            @input="input"
        />
    </div>
</template>

<script>
    import { ApiFactory } from "@/api/ApiFactory";
    import CheckboxSelect from "@/components/CheckboxSelect/CheckboxSelect.vue";

    const StatusApi = ApiFactory.get("status");

    export default {
        name: "StatiMultiSelect",
        components: {CheckboxSelect},
        props: {
            id: String,
            value: {
                type: Array,
                default: () => []
            },
            size: String,
            disabled: {
                type: Boolean,
                default: false
            },
            components: {
                CheckboxSelect
            },
        },
        data() {
            return {
                busy: false,
                data: [],
                options: [],
                localValue: this.value ? this.value : []
            }
        },
        created() {
            this.fetch();
        },
        watch: {
            value: {
                handler(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        this.localValue = newValue;
                    }
                }
            }
        },
        methods: {
            async fetch() {
                this.busy = true;

                const response = await StatusApi.get();

                if(response.ok) {
                    let items = response.json.collection;
                    this.options = items
                        .filter(item => item.value <= 80)
                        .sort((a,b) => a.value - b.value)
                        .map(item => {
                        return {
                            value: item.value,
                            text: `${item.value} (${item.name})`
                        }
                    });
                    this.data = items.filter(item => item.value <= 80);
                }

                this.busy = false;
            },
            input(value) {
                this.$emit("input", value);
            }
        }
    }

</script>